import { render, staticRenderFns } from "./PasswordResetDialog.vue?vue&type=template&id=4aeff7bd"
import script from "./PasswordResetDialog.vue?vue&type=script&lang=js"
export * from "./PasswordResetDialog.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetDialog.vue?vue&type=style&index=0&id=4aeff7bd&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports